import palette from '../../palette';

export default {
  root: {
    fontSize: "15px",
    "&:hover": {
      color: palette.blueMain,
      backgroundColor: "transparent"
    },
    "&$selected": {
      backgroundColor: "transparent",
      "&:hover": {
        backgroundColor: "transparent"
      },
    }
  },
};
